import { Component, OnInit } from '@angular/core';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-goal-card',
    templateUrl: './goal-card.component.html',
    styleUrls: ['./goal-card.component.css'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatCardActions, MatButton]
})
export class GoalCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
